(() => {
  const qs = (s, c = document) => c.querySelector(s);
  const qsa = (s, c = document) => [...c.querySelectorAll(s)];

  const drawer = qs('[data-mobile-drawer]');
  const openButton = qs('[data-menu-open]');
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    openButton?.setAttribute('aria-expanded', 'false');
  };
  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    openButton?.setAttribute('aria-expanded', 'true');
    qs('[data-menu-close]', drawer)?.focus();
  };
  openButton?.addEventListener('click', openDrawer);
  qsa('[data-menu-close]').forEach(el => el.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  qsa('[data-product-thumb]').forEach(button => {
    button.addEventListener('click', () => {
      const target = qs('#MainProductImage');
      if (!target) return;
      target.src = button.dataset.image;
      target.srcset = '';
      target.alt = button.dataset.alt || '';
      qsa('[data-product-thumb]').forEach(b => b.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });

  const revealItems = qsa('[data-reveal]');
  if ('IntersectionObserver' in window && revealItems.length) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .08 });
    revealItems.forEach(item => observer.observe(item));
  } else {
    revealItems.forEach(item => item.classList.add('is-visible'));
  }

  qsa('[data-count]').forEach(el => {
    const target = Number(el.dataset.count || 0);
    if (!target || !('IntersectionObserver' in window)) return;
    const suffix = el.dataset.suffix || '';
    const prefix = el.dataset.prefix || '';
    let played = false;
    const obs = new IntersectionObserver(entries => {
      if (!entries[0].isIntersecting || played) return;
      played = true;
      const start = performance.now();
      const tick = now => {
        const progress = Math.min((now - start) / 1100, 1);
        const value = Math.floor(target * (1 - Math.pow(1 - progress, 3)));
        el.textContent = `${prefix}${value.toLocaleString()}${suffix}`;
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      obs.disconnect();
    }, { threshold: .4 });
    obs.observe(el);
  });

  if (window.matchMedia('(pointer:fine)').matches) {
    qsa('.js-tilt').forEach(card => {
      card.addEventListener('mousemove', e => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - .5;
        const y = (e.clientY - r.top) / r.height - .5;
        card.style.transform = `perspective(700px) rotateX(${-y * 3}deg) rotateY(${x * 3}deg) translateY(-4px)`;
      });
      card.addEventListener('mouseleave', () => { card.style.transform = ''; });
    });
  }
})();
